import { useEffect, useRef } from 'react';

const useDidMount = (fn) => {
	const fnRef = useRef(fn);

	useEffect(() => {
		const clearFn = fnRef.current();

		return () => {
			if (clearFn) {
				clearFn();
			}
		};
	}, [fnRef]);
};

export default useDidMount;
